<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-money-bill"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView: Cadastro e Historico -->
<div class="tabs-container">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

    <!-- Aba 1: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-plus-circle tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <!-- Grid Responsivo: Formulario + Card Cotacao Atual -->
      <div class="grid">
        <!-- Card do Formulario (col-12 md:col-7) -->
        <div class="col-12 md:col-7">
          <div class="form-card">
            <!-- Banner de visualizacao (cotacao ja cadastrada nao pode ser editada) -->
            <div class="editing-banner" *ngIf="idEdit">
              <i class="pi pi-eye"></i>
              <span>{{ texts.visualizar_cotacao }}</span>
            </div>
            <div class="card-header">
              <div class="card-header-icon">
                <i class="pi pi-plus-circle" *ngIf="!idEdit"></i>
                <i class="pi pi-eye" *ngIf="idEdit"></i>
              </div>
              <span class="card-header-title">{{ idEdit ? texts.visualizar_cotacao : texts.nova_cotacao }}</span>
            </div>
            <div class="card-content">
              <!-- Moeda Padrao (somente em edicao) -->
              <div class="form-row" *ngIf="idEdit">
                <div class="form-item">
                  <label class="form-label">{{ labels.moeda_padrao }}</label>
                  <input
                    pInputText
                    [value]="moedaPadraoLabel"
                    [disabled]="true"
                    class="w-full" />
                </div>
              </div>

              <div class="form-row">
                <!-- Campos filtrados conforme a moeda padrao da empresa logada. -->
                <div class="form-item" *ngIf="isVisivel('dolarGuarani')">
                  <label class="form-label">
                    <div class="currency-pair">
                      <img src="assets/images/usa-flag.svg" class="flag-icon" alt="USA" />
                      <span class="currency-separator">{{ spans.x }}</span>
                      <img src="assets/images/paraguay-flag.jpg" class="flag-icon" alt="Paraguay" />
                      <span class="currency-name">{{ spans.dolar_guarani }}</span>
                    </div>
                  </label>
                  <!-- es-PY: PYG sem decimais, ponto como milhar -->
                  <p-inputNumber
                    [(ngModel)]="form.dolarGuarani"
                    [locale]="'es-PY'"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="0"
                    [min]="0"
                    [useGrouping]="true"
                    [placeholder]="placeholders.dolar_x_guarani"
                    [readonly]="!!idEdit"
                    [disabled]="!!idEdit"
                    styleClass="w-full"
                    inputStyleClass="w-full"></p-inputNumber>
                </div>
                <div class="form-item" *ngIf="isVisivel('realGuarani')">
                  <label class="form-label">
                    <div class="currency-pair">
                      <img src="assets/images/br-flag.svg" class="flag-icon" alt="BR" />
                      <span class="currency-separator">{{ spans.x }}</span>
                      <img src="assets/images/paraguay-flag.jpg" class="flag-icon" alt="Paraguay" />
                      <span class="currency-name">{{ spans.real_guarani }}</span>
                    </div>
                  </label>
                  <!-- es-PY: PYG sem decimais, ponto como milhar -->
                  <p-inputNumber
                    [(ngModel)]="form.realGuarani"
                    [locale]="'es-PY'"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="0"
                    [min]="0"
                    [useGrouping]="true"
                    [placeholder]="placeholders.real_x_guarani"
                    [readonly]="!!idEdit"
                    [disabled]="!!idEdit"
                    styleClass="w-full"
                    inputStyleClass="w-full"></p-inputNumber>
                </div>
                <div class="form-item" *ngIf="isVisivel('dolarReal')">
                  <label class="form-label">
                    <div class="currency-pair">
                      <img src="assets/images/usa-flag.svg" class="flag-icon" alt="USA" />
                      <span class="currency-separator">{{ spans.x }}</span>
                      <img src="assets/images/br-flag.svg" class="flag-icon" alt="BR" />
                      <span class="currency-name">{{ spans.dolar_real }}</span>
                    </div>
                  </label>
                  <!-- pt-BR (BRL): 2 decimais com virgula como separador decimal -->
                  <p-inputNumber
                    [(ngModel)]="form.dolarReal"
                    [locale]="'pt-BR'"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="2"
                    [min]="0"
                    [useGrouping]="true"
                    [placeholder]="placeholders.dolar_x_real"
                    [readonly]="!!idEdit"
                    [disabled]="!!idEdit"
                    styleClass="w-full"
                    inputStyleClass="w-full"></p-inputNumber>
                </div>
                <div class="form-item" *ngIf="isVisivel('pesoGuarani')">
                  <label class="form-label">
                    <div class="currency-pair">
                      <img src="assets/images/argentina-flag.svg" class="flag-icon" alt="Argentina" />
                      <span class="currency-separator">{{ spans.x }}</span>
                      <img src="assets/images/paraguay-flag.jpg" class="flag-icon" alt="Paraguay" />
                      <span class="currency-name">{{ spans.peso_guarani }}</span>
                    </div>
                  </label>
                  <!-- Aceita virgula como separador decimal (locale es-PY); fixa em 2 casas (NUMERIC(19,2)). -->
                  <p-inputNumber
                    [(ngModel)]="form.pesoGuarani"
                    [locale]="'es-PY'"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="2"
                    [min]="0"
                    [useGrouping]="true"
                    [placeholder]="placeholders.peso_x_guarani"
                    [readonly]="!!idEdit"
                    [disabled]="!!idEdit"
                    styleClass="w-full"
                    inputStyleClass="w-full"></p-inputNumber>
                </div>
              </div>
              <div class="form-actions">
                <!-- Em modo visualizacao (cotacao ja cadastrada) apenas o botao de voltar e exibido -->
                <button *ngIf="idEdit"
                  pButton
                  [label]="botoes.limpar"
                  icon="pi pi-times"
                  class="p-button-secondary"
                  (click)="novaCotacao()">
                </button>
                <button *ngIf="!idEdit"
                  pButton
                  [label]="botoes.guardar"
                  icon="pi pi-check"
                  (click)="submit()"
                  [disabled]="submitting || cotacaoCarregando"
                  [loading]="submitting || cotacaoCarregando">
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Card Cotacao Atual (col-12 md:col-5) -->
        <div class="col-12 md:col-5">
          <p-card styleClass="h-full">
            <ng-template pTemplate="header">
              <div class="card-header">
                <div class="card-header-icon cotacao-icon">
                  <i class="pi pi-chart-line"></i>
                </div>
                <span class="card-header-title">{{ texts.cotacao_atual }}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              <div *ngIf="cotacaoAtualCarregando" class="text-center">
                <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
                <p>{{ texts.carregando_cotacao }}</p>
              </div>
              <div *ngIf="!cotacaoAtualCarregando && !cotacaoAtual" class="text-center text-500">
                <i class="pi pi-info-circle" style="font-size: 2rem;"></i>
                <p>{{ texts.nenhuma_cotacao_atual }}</p>
              </div>
              <div *ngIf="!cotacaoAtualCarregando && cotacaoAtual" class="cotacao-atual-content">
                <!-- Cards filtrados conforme a moeda padrao da empresa logada. -->
                <div class="cotacao-item" *ngIf="isVisivel('dolarGuarani')">
                  <div class="currency-pair">
                    <img src="assets/images/usa-flag.svg" class="flag-icon-small" alt="USA" />
                    <span class="currency-separator">{{ spans.x }}</span>
                    <img src="assets/images/paraguay-flag.jpg" class="flag-icon-small" alt="Paraguay" />
                  </div>
                  <div class="currency-label">{{ spans.dolar_guarani }}</div>
                  <div class="currency-value">{{ cotacaoAtual.dolarGuarani | number: '1.0-0':'es-PY' }}</div>
                </div>
                <div class="cotacao-item" *ngIf="isVisivel('realGuarani')">
                  <div class="currency-pair">
                    <img src="assets/images/br-flag.svg" class="flag-icon-small" alt="BR" />
                    <span class="currency-separator">{{ spans.x }}</span>
                    <img src="assets/images/paraguay-flag.jpg" class="flag-icon-small" alt="Paraguay" />
                  </div>
                  <div class="currency-label">{{ spans.real_guarani }}</div>
                  <div class="currency-value">{{ cotacaoAtual.realGuarani | number: '1.0-0':'es-PY' }}</div>
                </div>
                <div class="cotacao-item" *ngIf="isVisivel('dolarReal')">
                  <div class="currency-pair">
                    <img src="assets/images/usa-flag.svg" class="flag-icon-small" alt="USA" />
                    <span class="currency-separator">{{ spans.x }}</span>
                    <img src="assets/images/br-flag.svg" class="flag-icon-small" alt="BR" />
                  </div>
                  <div class="currency-label">{{ spans.dolar_real }}</div>
                  <div class="currency-value">{{ cotacaoAtual.dolarReal | number: '1.2-2':'pt-BR' }}</div>
                </div>
                <div class="cotacao-item" *ngIf="isVisivel('pesoGuarani')">
                  <div class="currency-pair">
                    <img src="assets/images/argentina-flag.svg" class="flag-icon-small" alt="Argentina" />
                    <span class="currency-separator">{{ spans.x }}</span>
                    <img src="assets/images/paraguay-flag.jpg" class="flag-icon-small" alt="Paraguay" />
                  </div>
                  <div class="currency-label">{{ spans.peso_guarani }}</div>
                  <div class="currency-value">{{ cotacaoAtual.pesoGuarani != null ? (cotacaoAtual.pesoGuarani | number: '1.2-2':'es-AR') : '—' }}</div>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="footer">
              <div *ngIf="!cotacaoAtualCarregando && cotacaoAtual" class="cotacao-data">
                <i class="pi pi-calendar"></i>
                <span>{{ cotacaoAtual.emissao | date: 'dd/MM/yyyy HH:mm' }}</span>
              </div>
            </ng-template>
          </p-card>
        </div>
      </div>
    </p-tabPanel>

    <!-- Aba 2: Historico -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_historico }}</span>
      </ng-template>

      <!-- Card: Historico de Cotacoes -->
      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.historico_de_cotacoes }}</span>
          <div class="card-header-actions">
            <button pButton
              [label]="texts.nova_cotacao"
              icon="pi pi-plus"
              class="btn-primary btn-sm"
              (click)="novaCotacao()">
            </button>
          </div>
        </div>
        <div class="card-content">
          <!-- Barra de busca + Seletor de colunas -->
          <div class="search-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input pInputText type="text"
                [placeholder]="placeholders.buscar"
                [(ngModel)]="searchTerm"
                (ngModelChange)="onSearchChange($event)" />
            </p-iconField>

            <app-column-selector
              [columns]="columns"
              [storageKey]="STORAGE_KEY"
              (columnsChange)="onColumnsChange($event)">
            </app-column-selector>
          </div>

          <!-- Tabela -->
          <p-table [value]="cotacoes" [loading]="loading"
            (onSort)="onSortChange($event)"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('id')" pSortableColumn="id" style="width: 5%">
                  {{ labels.id }}<p-sortIcon [field]="'id'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('emissao')" pSortableColumn="emissao" style="width: 16%">
                  {{ labels.data_emissao }}<p-sortIcon [field]="'emissao'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('dolarGuarani')" pSortableColumn="dolarGuarani" style="width: 12%" class="num-col">
                  {{ labels.dolar_guarani }}<p-sortIcon [field]="'dolarGuarani'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('realGuarani')" pSortableColumn="realGuarani" style="width: 12%" class="num-col">
                  {{ labels.real_guarani }}<p-sortIcon [field]="'realGuarani'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('dolarReal')" pSortableColumn="dolarReal" style="width: 12%" class="num-col">
                  {{ labels.dolar_real }}<p-sortIcon [field]="'dolarReal'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('pesoGuarani')" pSortableColumn="pesoGuarani" style="width: 12%" class="num-col">
                  {{ labels.peso_guarani }}<p-sortIcon [field]="'pesoGuarani'"></p-sortIcon>
                </th>
                <th style="width: 5%" class="actions">
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-cotacao>
              <tr>
                <td [hidden]="!isColumnVisible('id')">
                  <span class="id-badge">{{ cotacao.id }}</span>
                </td>
                <td [hidden]="!isColumnVisible('emissao')">
                  <div class="date-cell">
                    <i class="pi pi-calendar"></i>
                    {{ cotacao.emissao | date: 'dd/MM/yyyy' }}
                  </div>
                </td>
                <td [hidden]="!isColumnVisible('dolarGuarani')" class="num-col value-cell">{{ cotacao.dolarGuarani | number: '1.0-0':'es-PY' }}</td>
                <td [hidden]="!isColumnVisible('realGuarani')" class="num-col value-cell">{{ cotacao.realGuarani | number: '1.0-0':'es-PY' }}</td>
                <td [hidden]="!isColumnVisible('dolarReal')" class="num-col value-cell">{{ cotacao.dolarReal | number: '1.2-2':'pt-BR' }}</td>
                <td [hidden]="!isColumnVisible('pesoGuarani')" class="num-col value-cell">
                  {{ cotacao.pesoGuarani != null ? (cotacao.pesoGuarani | number: '1.2-2':'es-AR') : '—' }}
                </td>
                <td class="actions">
                  <button pButton pRipple icon="pi pi-eye"
                    class="p-button-rounded p-button-text action-btn edit-btn"
                    [pTooltip]="tooltips.visualizar" tooltipPosition="top"
                    (click)="visualizarCotacao(cotacao.id)">
                  </button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount + 1" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhuma_cotacao }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.adicione_cotacao }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount + 1" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onPageChange($event)"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="first" [rows]="rows"
                [totalRecords]="totalRecords"
                [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="rows"
                (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

  </p-tabView>
</div>

<p-toast></p-toast>
